import { Grid } from "@mui/material";
import React, { useState } from "react";
import UpdateWallet from "../createtransaction/changewallet";

const ChangeWalletIndex = () => {
  const walletArray = [
    "BTC",
    "BNB",
    "TRX",
    "ETH",
    "USDT (TRC20)",
    "USDT(ERC20)",
  ];

  return (
    <Grid container spacing={4}>
      {walletArray.map((wallet, index) => (
        <Grid item xs={12} md={6}>
          <UpdateWallet cointitle={wallet} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ChangeWalletIndex;
